"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventContract = exports.ExternalEventContract = exports.GreenlineEvent = exports.GreenlineEventTypes = exports.GreenlineEventKeys = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const companies_1 = require("./domains/companies");
const locations_1 = require("./domains/locations");
const users_1 = require("./domains/users");
const customers_1 = require("./domains/customers");
var GreenlineEventKeys;
(function (GreenlineEventKeys) {
    // Employees
    GreenlineEventKeys["EMPLOYEE_CREATED"] = "employee-created";
    GreenlineEventKeys["EMPLOYEE_UPDATED"] = "employee-updated";
    // Customers
    GreenlineEventKeys["CUSTOMER_CREATED"] = "customer-created";
    GreenlineEventKeys["CUSTOMER_UPDATED"] = "customer-updated";
    // Payments
    GreenlineEventKeys["PAYMENT_CREATED"] = "payment-created";
    GreenlineEventKeys["PAYMENT_UPDATED"] = "payment-updated";
    // Inventory
    GreenlineEventKeys["INVENTORY_UPDATED"] = "inventory-updated";
    // PaymentQueue
    GreenlineEventKeys["PAYMENTQUEUE_CREATED"] = "paymentQueue-created";
    GreenlineEventKeys["PAYMENTQUEUE_UPDATED"] = "paymentQueue-updated";
    // Products
    GreenlineEventKeys["PRODUCT_CREATED"] = "product-created";
    GreenlineEventKeys["PRODUCT_UPDATED"] = "product-updated";
    GreenlineEventKeys["PRODUCT_DELETED"] = "product-deleted";
    // Categories
    GreenlineEventKeys["CATEGORY_CREATED"] = "category-created";
    GreenlineEventKeys["CATEGORY_UPDATED"] = "category-updated";
    GreenlineEventKeys["CATEGORY_DELETED"] = "category-deleted";
    // Discounts
    GreenlineEventKeys["DISCOUNT_CREATED"] = "discount-created";
    GreenlineEventKeys["DISCOUNT_UPDATED"] = "discount-updated";
    GreenlineEventKeys["DISCOUNT_DELETED"] = "discount-deleted";
    // External source
    GreenlineEventKeys["EXTERNAL_SOURCE_UPDATED"] = "externalSource-updated";
})(GreenlineEventKeys || (exports.GreenlineEventKeys = GreenlineEventKeys = {}));
var GreenlineEventTypes;
(function (GreenlineEventTypes) {
    // Employees
    GreenlineEventTypes["EMPLOYEE_CREATED"] = "employee.created";
    GreenlineEventTypes["EMPLOYEE_UPDATED"] = "employee.updated";
    // Customers
    GreenlineEventTypes["CUSTOMER_CREATED"] = "customer.created";
    GreenlineEventTypes["CUSTOMER_UPDATED"] = "customer.updated";
    // Payments
    GreenlineEventTypes["PAYMENT_CREATED"] = "payment.created";
    GreenlineEventTypes["PAYMENT_UPDATED"] = "payment.updated";
    // Inventory
    GreenlineEventTypes["INVENTORY_UPDATED"] = "inventory.updated";
    // PaymentQueue
    GreenlineEventTypes["PAYMENTQUEUE_CREATED"] = "paymentQueue.created";
    GreenlineEventTypes["PAYMENTQUEUE_UPDATED"] = "paymentQueue.updated";
    // Products
    GreenlineEventTypes["PRODUCT_CREATED"] = "product.created";
    GreenlineEventTypes["PRODUCT_UPDATED"] = "product.updated";
    GreenlineEventTypes["PRODUCT_DELETED"] = "product.deleted";
    // Categories
    GreenlineEventTypes["CATEGORY_CREATED"] = "category.created";
    GreenlineEventTypes["CATEGORY_UPDATED"] = "category.updated";
    GreenlineEventTypes["CATEGORY_DELETED"] = "category.deleted";
    // Discounts
    GreenlineEventTypes["DISCOUNT_CREATED"] = "discount.created";
    GreenlineEventTypes["DISCOUNT_UPDATED"] = "discount.updated";
    GreenlineEventTypes["DISCOUNT_DELETED"] = "discount.deleted";
    // External sources
    GreenlineEventTypes["EXTERNAL_SROUCE_UPDATED"] = "externalSource.updated";
})(GreenlineEventTypes || (exports.GreenlineEventTypes = GreenlineEventTypes = {}));
class GreenlineEvent {
    static create(cls, plain) {
        return GreenlineEvent.validate((0, class_transformer_1.plainToClass)(cls, plain, { excludeExtraneousValues: true }));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static validate(Contract, params) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const instance = typeof Contract === 'function' ? new Contract(params) : Contract;
        const errors = (0, class_validator_1.validateSync)(instance, { skipMissingProperties: true });
        if (errors.length > 0) {
            throw errors;
        }
        return instance;
    }
}
exports.GreenlineEvent = GreenlineEvent;
class ExternalEventContract {
    constructor(params) {
        this.company = GreenlineEvent.create(companies_1.ExternalCompanyEventDataContract, params.company);
        if (params.location) {
            this.location = GreenlineEvent.create(locations_1.ExternalLocationEventDataContract, params.location);
        }
        if (params.user) {
            this.user = GreenlineEvent.create(users_1.ExternalUserEventDataContract, params.user);
        }
    }
}
exports.ExternalEventContract = ExternalEventContract;
class EventContract {
    constructor(params) {
        this.company = GreenlineEvent.create(companies_1.CompanyEventDataContract, params.company);
        if (params.location) {
            this.location = GreenlineEvent.create(locations_1.LocationEventDataContract, params.location);
        }
        if (params.user) {
            this.user = GreenlineEvent.create(users_1.UserEventDataContract, params.user);
        }
        if (params.customer) {
            this.customer = GreenlineEvent.create(customers_1.CustomerEventDataContract, params.customer);
        }
    }
}
exports.EventContract = EventContract;
//# sourceMappingURL=base.js.map